// @ts-nocheck
import React, { useState, useEffect, useContext, useRef } from 'react';
import Breadcrumbs from '@/components/breadcrumbs';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import ToastContext from '@/utils/toast-context';
import SettingsMenu from '@/components/settings/menu';
import Router from 'next/router';
import SCPasswordInput from '@/components/sc-controls/form-controls/sc-password-input';
import Button from '@/components/button';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import ConfirmAction from '@/components/modals/confirm-action';
import Storage from '@/utils/storage';
import { Text } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import { createFileRoute } from '@tanstack/react-router'
import { PlatformAuthService } from '@/services/platform-auth';

const auth = new PlatformAuthService();

function ChangePassword() {

  const toast = useContext(ToastContext);
  let currPath = "";
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const [inputErrors, setInputErrors] = useState<any>({});

  const [password, setPassword] = useState('');

  const handlePasswordChange = (e: any) => {
    setPassword(e.value);
  };

  const [newPassword, setNewPassword] = useState('');

  const handleNewPasswordChange = (e: any) => {
    setNewPassword(e.value);
  };

  const [confirmPassword, setConfirmPassword] = useState('');

  const handleConfirmPasswordChange = (e: any) => {
    setConfirmPassword(e.value);
  };

  // Build a consistent set of user/company words for password strength checks
  const userwords = [
    Storage?.getCookie ? Storage.getCookie(Enums.Cookie?.servUserName) : undefined,
    Storage?.getCookie ? Storage.getCookie(Enums.Cookie?.servFullName) : undefined,
    Storage?.getCookie ? Storage.getCookie(Enums.Cookie?.servCompanyName) : undefined,
  ].filter(Boolean);

  const validate = () => {
    let validationItems = [
      { key: 'Password', value: password, required: true, type: Enums.ControlType.Text },
      { key: 'NewPassword', value: newPassword, required: true, type: Enums.ControlType.Text },
      { key: 'ConfirmPassword', value: confirmPassword, required: true, type: Enums.ControlType.Text, equalsPassword: newPassword }
    ];
    let { isValid, errors } = Helper.validateInputs(validationItems);

    // Global password strength validation (min 10 chars, composition, common words)
    const strengthError = Helper.getPasswordStrengthError(newPassword, { userwords });
    if (strengthError) {
      isValid = false;
      (errors as any).NewPassword = strengthError;
    }

    if (newPassword?.length > 100) {
      isValid = false;
      (errors as any).NewPassword = 'Please use a password of 100 characters or less';
    }
    setInputErrors(errors);
    return isValid;
  };

  const changePassword = async () => {
    const isValid = validate();
    if (isValid) {
      confirmChangePassword();
    } else {
      toast.setToast!!!({
        message: 'There are errors on the page',
        show: true,
        type: 'error'
      });
    }
  };

  const confirmChangePassword = async () => {
    setConfirmOptions({
      display: true,
      heading: "Confirm",
      text: "Are you sure you want to change your password?",
      confirmButtonText: "Confirm",
      showCancel: true,
      onConfirm: async () => {
        changePasswordConfirmed();
      }
    });
  };

  const changePasswordConfirmed = async () => {
    try {
      if (!auth.userId) {
        showNotification({ color: 'yellow.7', message: 'Your session has expired. Please re-login and try again.', autoClose: 5000 });
        return;
      }
      await auth.changePassword(password, newPassword);

      toast.setToast!!!({
        message: 'Your password has been changed',
        show: true,
        type: 'success'
      });
    } catch (error) {
      const msg = (error as any)?.message || 'Something went wrong';
      setInputErrors((prev: any) => ({ ...prev, Password: msg }));
      showNotification({ color: 'yellow.7', message: msg, autoClose: 5000 });
    }
  };

  const initialiseConfirmOptions = () => {
    return {
      display: false,
      heading: "",
      text: "",
      onConfirm: () => { },
      onCancel: () => { },
      onDiscard: () => { },
      confirmButtonText: "OK",
      cancelButtonText: "Cancel",
      discardButtonText: "Discard",
      showCancel: true,
      showDiscard: false
    };
  };

  const [confirmOptions, setConfirmOptions] = useState(initialiseConfirmOptions);

  function setPasswordErrorFromMessage(message: any) {
    const msg = message ?? '';
    const lower = String(msg).toLowerCase();
    const isExisting = lower.includes('existing') || lower.includes('current');
    setInputErrors((prev: any) => ({ ...prev, [isExisting ? 'Password' : 'NewPassword']: msg }));
  }

  return (
    <div className="settings-container">
      {/*<div className="row">
        <div className="title">
          <Breadcrumbs
            crumbs={[
              { text: 'Settings', link: '/settings', suppressLink: true },
              { text: 'Update Password', link: '/settings/change-password' },
            ]}
          />
        </div>
      </div>*/}
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <div className="settings-card">
          <div className="row">
            <div className="column">
              <h2>Update Your Password</h2>
            </div>
            <div className="column column-end">
              <Button text="Update Password" extraClasses="fit-content save" onClick={changePassword} />
            </div>
          </div>
          {/* <div className='row'>
            <div className='column'>
              <SCInput
                name="Username"
                label="Username"
                value={Storage.getCookie(Enums.Cookie.servUserName)}
                readOnly={true}
                userwords={userwords}
              />
            </div>
            <div className='column'>

            </div>
          </div> */}
          <div className="row">
            <div className="column">
              <SCPasswordInput
                name="Password"
                label="Existing Password"
                onChange={handlePasswordChange}
                required={true}
                value={password}
                error={inputErrors.Password}
                autoComplete="new-password"
                showPopover={false}
              />
            </div>
            <div className="column">

            </div>
          </div>
          <div className="row">
            <div className="column">
              <SCPasswordInput
                name="NewPassword"
                label="New Password"
                onChange={handleNewPasswordChange}
                required={true}
                value={newPassword}
                error={inputErrors.NewPassword}
                autoComplete="new-password"
                userwords={userwords}
              />
            </div>
            <div className="column">
              <SCPasswordInput
                label="Confirm Password"
                onChange={handleConfirmPasswordChange}
                required={true}
                value={confirmPassword}
                error={inputErrors.ConfirmPassword}
                autoComplete="new-password"
                userwords={userwords}
              />
            </div>
          </div>
            <Text size="sm" c="dimmed" mt={25}>
                Choose a strong password with at least 10 characters, including uppercase, lowercase, and a number. Skip common phrases like 'password', 'qwerty', '1234', or your name.
            </Text>
        </div>
      </div>

      <ConfirmAction options={confirmOptions} setOptions={setConfirmOptions} />

      <style jsx>{`
        .row {
          display: flex;
          justify-content: space-between;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: 100%;
        }
        .column-end {
          align-items: flex-end;
        }
        .column-margin {
          margin-left: 24px;
        }
        .column + .column {
          margin-left: 1.25rem;
        }
        p {
          color: ${colors.darkPrimary};
        }
        h3 {
          color: ${colors.darkPrimary};
          font-size: 1.75rem;
          font-weight: lighter;
          margin: 1rem 0 1rem;
        }
      `}</style>
    </div>
  );
}

export default ChangePassword;

export const Route = createFileRoute('/_authenticated/settings/change-password')({ component: ChangePassword })
